import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "proi-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxRemoteOperations = _resolveComponent("DxRemoteOperations")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormPopup = _resolveComponent("DxFormPopup")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.ds,
      ref: "gridRef",
      "key-expr": "ID",
      "show-borders": true,
      height: "100%",
      "row-alternation-enabled": true,
      "hover-state-enabled": true,
      "no-data-text": "Nu există pontaj pe proiecte pentru angajatul selectat."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxRemoteOperations, {
          filtering: true,
          paging: true,
          sorting: true
        }),
        _createVNode(_component_DxScrolling, { mode: "virtual" }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          "allow-deleting": true,
          "allow-adding": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              "show-title": true,
              title: "Pontaj proiect",
              width: 520,
              height: 360
            }),
            _createVNode(_component_DxFormPopup, { "col-count": 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, { "data-field": "ProiectID" }),
                _createVNode(_component_DxItem, { "data-field": "OraInceput" }),
                _createVNode(_component_DxItem, { "data-field": "OraFinal" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ProiectID",
          caption: "Proiect",
          "min-width": 200
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsProiecte,
              "value-expr": "ProiectId",
              "display-expr": "Name"
            }, null, 8, ["data-source"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "OraInceput",
          caption: "Oră început",
          "data-type": "datetime",
          format: "dd.MM.yyyy HH:mm",
          width: 160
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "OraFinal",
          caption: "Oră sfârșit",
          "data-type": "datetime",
          format: "dd.MM.yyyy HH:mm",
          width: 160
        }),
        _createVNode(_component_DxColumn, {
          caption: "Durată (h)",
          width: 100,
          alignment: "center",
          "calculate-cell-value": _ctx.durata,
          "allow-editing": false
        }, null, 8, ["calculate-cell-value"])
      ]),
      _: 1
    }, 8, ["data-source"])
  ]))
}